<div class="loader" [ngClass]="layout ? 'layout-' + layout : ''">
  <svg class="spinner" width="70px" height="70px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle [attr.stroke]="color " class="path" fill="none" stroke-width="8" cx="33" cy="33" r="28"></circle>
 </svg>
</div>
